
import Vue from 'vue'
import ContactNote from '@/components/ContactNote.vue'

export default Vue.extend({
  components: {
    ContactNote
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: 'Please select'
    },
    dropDownItems: {
      type: Array,
      required: true
    },
    activeItem: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isActive: false
    }
  },
  computed: {
    hasDropdownItems(): boolean {
      return this.dropDownItems.length > 0
    },
    isColorPattern(): boolean {
      if (!this.hasDropdownItems) return false
      return this.dropDownItems.some((element:any) => {
        if (element.hasOwnProperty('color_pattern')) {
          return true
        }
        return false
      })
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    hasColorPattern(item: any): boolean {
      if (!item) return false
      return item.hasOwnProperty('color_pattern')
    },
    quantityLabel(quantity: number): string {
      if (!quantity || quantity == 1) return 'No Minimum Quantity'
      else return 'Minimum Quantity = '
    },
    onClickItem(id: number) {
      if (id === this.activeItem) return
      this.$emit('updateSelection', this.name, id)
      this.isActive = false
    },
     handleClickOutside(event: any) {
      if (!this.$el.contains(event.target)) {
        this.isActive = false
      }
    }
  }
})
